<template>
  <div class="app-container">
    <el-row
      style="margin-top: 20px; margin-bottom: 10px"
      :gutter="10"
      class="mb8"
    >
      <el-col :span="3">
        <el-input
          clearable
          size="mini"
          v-model="param.keywords"
          placeholder="请输入关键字"
        ></el-input>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="warning"
          icon="el-icon-search"
          size="mini"
          @click="GetCallforPapersDatas"
          >搜索</el-button
        >
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd"
          >新增</el-button
        >
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="success"
          icon="el-icon-edit"
          size="mini"
          :disabled="single"
          @click="handleUpdate"
          >修改</el-button
        >
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="danger"
          icon="el-icon-delete"
          size="mini"
          :disabled="multiple"
          @click="handleDelete"
          >删除</el-button
        >
      </el-col>
    </el-row>

    <el-table :data="PaperData">
      <el-table-column type="selection" width="30" />
      <el-table-column prop="topic" width="240" label="主题"> </el-table-column>
      <!-- <el-table-column
        prop="main_body"
        label="正文"
        width="550"
        show-overflow-tooltip
      ></el-table-column> -->
      <el-table-column prop="guest_editor"  label="客座编辑"></el-table-column>
      <el-table-column prop="like_counts" label="被关注数量"></el-table-column>
      <el-table-column prop="create_time"  label="创建时间"></el-table-column>
      <el-table-column prop="update_time"  label="更新时间"></el-table-column>
      <el-table-column prop="deadline"  label="截至日期"></el-table-column>
      <el-table-column
        label="操作"
        width="120"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <i
            class="el-icon-edit"
            style="color: rgb(24, 144, 255); cursor: pointer"
            @click="handleUpdate(scope.row)"
            >修改</i
          >
          <i
            style="margin-left: 10px; color: rgb(24, 144, 255); cursor: pointer"
            class="el-icon-delete"
            @click="handleDelete(scope.row)"
            >删除</i
          >
        </template>
      </el-table-column>
    </el-table>

    <pagination
      :total="total"
      :page.sync="param.pageNum"
      :limit.sync="param.pageSize"
      @pagination="GetCallforPapersData"
    />

    <el-dialog :title="dialogTitle" :close-on-click-modal="false" :visible.sync="dialogVisible" width="60%">
      <el-form
        :model="form"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="专刊主题" prop="topic">
          <el-input
            v-model="form.topic"
            placeholder="请输入专刊主题"
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="截止日期" prop="deadline">
              <el-date-picker
                :picker-options="pickerOptions"
                style="width: 100%"
                v-model="form.deadline"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择截止日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="正文" prop="main_body" :height="400">
          <!-- <el-input
            v-model="form.main_body"
            placeholder="请输入正文"
            :height="400"
            show-word-limit
          ></el-input> -->
          <editor
            :minHeight="200"
            :height="400"
            v-model="form.main_body"
          ></editor>
        </el-form-item>
        <el-form-item label="客座主编" prop="guest_editor">
          <el-input
            v-model="form.guest_editor"
            placeholder="请输入客座主编"
          ></el-input>
        </el-form-item>
        <el-form-item label="专刊链接" prop="url">
          <el-input
            v-model="form.url"
            placeholder="请输入专刊链接"
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="期刊" prop="journal_id">
              <el-select
                class="mr10"
                style="width: 100%"
                v-model="form.journal_id"
                filterable
                clearable
                placeholder="请选择支持期刊"
                :loading="selectLoading"
              >
                <el-input
                  v-model="searchSelect"
                  size="small"
                  placeholder="请输入搜索内容"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="searchSelectGet"
                  ></el-button>
                </el-input>
                <el-option label="期刊列表" :value="0"></el-option>
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  search_monograph,
  update_monograph,
  add_monograph,
  delete_monograph,
  search_journal_name,
} from "../../api/CallforPapers";
import editor from "./editor.vue";
export default {
  name: "PostManagement",
  components: {
    editor
  },
  data() {
    return {
      selectLoading: false,
      valueType: "",
      Included: [], //收录期刊
      IncludedList: [], //收录期刊
      NotIncluded: "", //未收录期刊
      options: [], //收录的期刊列表
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      searchSelect: "",
      form: {
        // topic: "",
        // create_time: "",
        // deadline: "",
        // guest_editor: "",
        // main_body: "",
        // url: "",
        // update_time: "",
        // like_counts: "",
        // journal_id: "",
        // id: "",
      },
      PaperData: [],
      param: {
        keywords: "",
        pageNum: 1,
        pageSize: 10,
      },
      dialogVisible: false,
      dialogTitle: "新增专刊",
      total: 0,
      rules: {},
    };
  },
  created() {
    this.GetCallforPapersData();
  },
  methods: {
    //   选择文件
    handleChange(row) {
      this.Files = row.raw;
    },

    //获取专刊数据
    GetCallforPapersData() {
      search_monograph(this.param).then((res) => {
        this.PaperData = res.data.list;
        this.total = res.data.total;
      });
    },

    // 点击获取专刊列表数据
    GetCallforPapersDatas() {
      this.param.pageNum = 1;
      this.param.pageSize = 10;
      search_monograph(this.param).then((res) => {
        this.PaperData = res.data.list;
        this.total = res.data.total;
      });
    },

    // 根据关键字搜索支持期刊列表
    searchSelectGet() {
      this.selectLoading = true;
      setTimeout(() => {
        search_journal_name({
          keywords: this.searchSelect,
        }).then((res) => {
          this.options = res.data.list;
          this.selectLoading = false;
        });
      }, 2000);
    },

    handleAdd() {
      this.form = {}
      this.dialogTitle = "新增专刊";
      this.dialogVisible = true;
    },
    handleUpdate(item) {
      this.dialogTitle = "修改专刊";
      this.dialogVisible = true;
      this.form = item;
    },
    handleDelete(item) {
      var id;
      if (item.id) {
        id = [item.id];
      } else {
        id = this.ids;
      }
      this.$confirm("此操作将永久删除该专刊, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delete_monograph({ id_list: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "已删除",
              });
              this.GetCallforPapersData();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    cancel() {
      this.dialogTitle = "新增专刊";
      this.dialogVisible = false;
      this.form = {};
      this.GetCallforPapersData();
    },
    confirm() {
      if (this.form.id) {
        update_monograph(this.form).then((res) => {
          if (res.code == 200) {
            this.cancel();
          }
        });
      } else {
        // console.log(this.from, 88);
        add_monograph(this.form).then((res) => {
          if (res.code == 200) {
            this.cancel();
          }
        });
      }
      // add_monograph(this.form).then((res) => {
      //   if (res.code == 200) {
      //     this.cancel();
      //   }
      // });
    },
  },
};
</script>

<style>
.cellstyle {
  height: 63px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}
.el-tooltip__popper{font-size: 14px; max-width:50% }
</style>
